import styled from '@emotion/styled'
import { isNumber } from 'utils/types'
import { stylesIf } from 'utils/styles'

const iconSizes = {
  large: 22,
  medium: 18,
  small: 16,
  'x-small': 12,
}

const withStyle = (Component) =>
  styled(Component)(
    (props) => `
        cursor: ${props.onClick ? 'pointer' : 'inherit'};
      `
  )

export default withStyle

export const IconMoon = styled.svg((props) => {
  const {
    fill,
    hoverFill,
    size,
    showHover,
    theme: { inactiveIconColor, hoverIconColor, color },
    theme,
    style,
    width,
    height,
  } = props

  const svgSize = isNumber(size) ? size : iconSizes[size] || 18
  const fillColor = theme[fill] || color[fill] || fill || inactiveIconColor
  const hoverFillColor = hoverFill
    ? color[hoverFill] || hoverFill || hoverIconColor
    : fillColor

  const hoverStyle = `
    &:hover {
      path { 
        fill: ${hoverFillColor};
      }
    }
  `

  return `
  &&{
    width: ${width || svgSize}px;
    height: ${height || svgSize}px;
    vertical-align: text-bottom;

    path {
      fill: ${fillColor};
    }

    ${stylesIf(showHover, hoverStyle)}
    ${style};
  }
  `
})
